/**
 * Development-only logger. In production, log/debug/warn are no-ops;
 * only error() is emitted for critical failures.
 */
const isDev = typeof process !== 'undefined' && process.env.NODE_ENV !== 'production';

export const logger = {
  log: (...args) => (isDev && console.log(...args)),
  debug: (...args) => (isDev && console.debug(...args)),
  warn: (...args) => (isDev && console.warn(...args)),
  error: (...args) => console.error(...args),
};

export default logger;
